/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BridgeApiConversationStatus } from './BridgeApiConversationStatus';
import {
    BridgeApiConversationStatusFromJSON,
    BridgeApiConversationStatusFromJSONTyped,
    BridgeApiConversationStatusToJSON,
    BridgeApiConversationStatusToJSONTyped,
} from './BridgeApiConversationStatus';

/**
 * 
 * @export
 * @interface BridgeApiUpdateConversation
 */
export interface BridgeApiUpdateConversation {
    /**
     * 
     * @type {BridgeApiConversationStatus}
     * @memberof BridgeApiUpdateConversation
     */
    status: BridgeApiConversationStatus;
}



/**
 * Check if a given object implements the BridgeApiUpdateConversation interface.
 */
export function instanceOfBridgeApiUpdateConversation(value: object): value is BridgeApiUpdateConversation {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function BridgeApiUpdateConversationFromJSON(json: any): BridgeApiUpdateConversation {
    return BridgeApiUpdateConversationFromJSONTyped(json, false);
}

export function BridgeApiUpdateConversationFromJSONTyped(json: any, ignoreDiscriminator: boolean): BridgeApiUpdateConversation {
    if (json == null) {
        return json;
    }
    return {
        
        'status': BridgeApiConversationStatusFromJSON(json['status']),
    };
}

export function BridgeApiUpdateConversationToJSON(json: any): BridgeApiUpdateConversation {
    return BridgeApiUpdateConversationToJSONTyped(json, false);
}

export function BridgeApiUpdateConversationToJSONTyped(value?: BridgeApiUpdateConversation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': BridgeApiConversationStatusToJSON(value['status']),
    };
}

